module.exports = __webpack_public_path__ + "static/media/flowers_13.25245ea9.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_13.csv
// module id = 752
// module chunks = 0